import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMX: CultureInfo = {
  name: 'en-MX',
  displayName: 'English (Mexico)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MX',
  parent: CultureInfoEn
};
